import { Pagination, TextField } from "@mui/material";
import Grid from "@mui/material/Grid2";
import React, { useEffect, useState } from "react";
import { ARTICLE_URL } from "../../Constants/Constants";
import { isEmpty } from "../../Constants/RolesConstants";
import AxiosInstance from "../../services/AxiosInstance";
import ArticleDialog from "./ArticleDialog";
//Table view
import GridViewIcon from "@mui/icons-material/GridView";
import ListIcon from "@mui/icons-material/List";
import { createTheme, ThemeProvider, useTheme } from "@mui/material";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import Paper from "@mui/material/Paper";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import Tooltip from "@mui/material/Tooltip";
import { styled } from "@mui/material/styles";
import Container from "react-bootstrap/Container";
import AppTableView from "../AppTableView";
import { SOLUTIONS_ARTICLES_COLUMNS } from "../ticket/grid/GridDataConstants";
const iconButtonStyle = {
  transition: "transform 0.2s, background-color 0.2s",
  margin: "0 8px",
  padding: "4px",
  borderRadius: "50%",
};

const selectedStyle = {
  backgroundColor: "#1976d2",
  color: "#fff",
  transform: "scale(1.2)",
};

const Article = ({ componentPermissions }) => {
  const globaltheme = useTheme();
  const theme = createTheme({
    ...globaltheme,
    components: {
      MuiSelect: {},
    },
  });
  const [articles, setArticles] = useState([]);
  const [filteredArticles, setFilteredArticles] = useState([]);
  const [page, setPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState("");
  const [viewListMode, setViewListMode] = useState(true);

  const [rowsPerPage, setRowsPerPage] = React.useState(5);
  const [gridPage, setGridPage] = useState(0);
  // Simulate fetching categories
  useEffect(() => {
    getArticles();
  }, []);

  const getArticles = () => {
    AxiosInstance.get(ARTICLE_URL).then((response) => {
      setArticles(response.data.data);
      setFilteredArticles(response.data.data);
    });
  };
  // Handle search term change
  const handleSearch = (event) => {
    const term = event.target.value.toLowerCase();
    setSearchTerm(term);
    setFilteredArticles(
      articles.filter((article) => article.title.toLowerCase().includes(term))
    );
  };

  // Handle pagination change
  const handlePageChange = (event, value) => {
    setPage(value);
  };

  const handleViewModeChange = (event) => {
    if (viewListMode === true) {
      setViewListMode(false);
    } else {
      setViewListMode(true);
      setGridPage(0);
      setPage(1);
    }
  };

  // Pagination variables
  const articlesPerPage = 3;
  const totalPages = Math.ceil(filteredArticles.length / articlesPerPage);
  const currentArticles = filteredArticles.slice(
    (page - 1) * articlesPerPage,
    page * articlesPerPage
  );

  return (
    <>
    <ThemeProvider theme={theme}>
      <div>
        <Grid container spacing={2} columns={16}>
          <Grid size={14}>
            {isEmpty(componentPermissions) ||
              componentPermissions ?.canCreate ? (
                <ArticleDialog
                  articleId={0}
                  selectedArticleName={""}
                  callArticles={getArticles}
                  componentPermissions={componentPermissions}
                  actionType="Add"
                  isEdit={false}
                />
              ) : null}
          </Grid>

          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              border: "1px solid #ddd",
              borderRadius: "8px",
              padding: "8px",
              width: "fit-content",
              margin: "auto",
            }}
          >
            <Tooltip title="List View" arrow>
              <IconButton
                onClick={() => setViewListMode(true)}
                style={{
                  ...iconButtonStyle,
                  ...(viewListMode ? selectedStyle : {}),
                }}
              >
                <ListIcon fontSize="small" />
              </IconButton>
            </Tooltip>
            <Tooltip title="Grid View" arrow>
              <IconButton
                onClick={() => setViewListMode(false)}
                style={{
                  ...iconButtonStyle,
                  ...(!viewListMode ? selectedStyle : {}),
                }}
              >
                <GridViewIcon fontSize="small" />
              </IconButton>
            </Tooltip>
          </Box>
        </Grid>
        <br />
      </div>
    </ThemeProvider>
    <div>
      {viewListMode === true ? (
        <Container fluid sx={{ padingLeft: "2px" }}>
          {/* <AssetItemDialog assetItemData={categoryData} callAssetItems={categoryData}/> */}
          {/* Add New Article Button */}

          <Box sx={{ width: "100%" }}>
            <Paper sx={{ width: "100%", mb: 2 }}>
              <AppTableView
                rows={articles}
                cols={SOLUTIONS_ARTICLES_COLUMNS({
                  getArticles,
                  componentPermissions,
                  actionType:
                  isEmpty(componentPermissions) ||
                    componentPermissions ?.["canUpdate"]
                      ? "Edit"
                      : "",
                })}
                initialPageSize={15}
              />
            </Paper>
          </Box>
        </Container>
      ) : (
          <div>
            {/* Search Box */}
            <ThemeProvider theme={theme}>
              <TextField
                label="Search Articles"
                variant="outlined"
                fullWidth
                value={searchTerm}
                onChange={handleSearch}
                style={{ marginBottom: 20, width: "99%" }}
              />
            </ThemeProvider>

            {/* Article List */}
            <Grid container spacing={3}>
              {currentArticles.map((article) => (
                <Grid item xs={12} sm={6} md={4} key={article.id}>
                  <div style={{ padding: 20, border: "1px solid #ddd" }}>
                    {/* <b>{article.id}</b> */}
                    <h2>
                      <ArticleDialog
                        articleId={article.id}
                        selectedArticleName={article.id}
                        callArticles={getArticles}
                      />
                    </h2>
                    <h5>{article.title}</h5>
                    <p>{article.summary}</p>
                  </div>
                </Grid>
              ))}
            </Grid>

            {/* Pagination */}
            <Pagination
              count={totalPages}
              page={page}
              onChange={handlePageChange}
              style={{
                marginTop: 20,
                display: "flex",
                justifyContent: "center",
              }}
            />

            {/* Dialog for Adding Article */}
          </div>
        )}
    </div>
    </>
  );
};

export default Article;
